import { Navbar } from "@/components/headtail/Navbar/Navbar";
import Footer from "@/components/Footer";

import "@/assets/style/legal.scss";
import "@/assets/style/style.scss";
import "@/assets/style/new_design.scss";
import "@/assets/style/error.scss";
import "@/assets/style/travel_restriction.scss";
import "@/assets/style/contact-us.scss";
import "@/assets/style/breadcrumb.scss";
import "@/assets/style/footer.scss";
import "react-phone-input-2/lib/style.css";



export default function LayoutDefault({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}





